"use client";

import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Avatar,
  IconButton,
  Alert,
  Stack,
} from "@mui/material";

export default function PMineTest() {
  return (
    <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1 }}>
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          fontWeight: 500,
        }}
      >
        PMineTest
      </Typography>
      <Typography>
        Comming soon
      </Typography>
    </Box>
  );
}
